import { useContext, useState } from "react";
import { UserContext } from "../../contexts/user.context";
import { toast } from "react-toastify";
import { handleError, Patch } from "../../utils/fetch.util";

export const PasswordReset = () => {
  const { getValidToken } = useContext(UserContext);

  const [formData, setFormData] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Handle password reset logic here
    if (formData.password !== formData.confirmPassword) {
      toast.error("New passwords do not match");
      return;
    }

    const res = await Patch(
      "asdc-client-user/reset-my-password-for-the-first-time",
      formData,
      getValidToken()
    );

    if (res.message === "Must be CLIENT user to access this route") {
      const res = await Patch(
        "asdc-admin/reset-my-password-for-the-first-time",
        formData,
        getValidToken()
      );

      if (res.error) {
        handleError(res);
        return;
      } else {
        toast.success("Password reset successfully");
        // reload page
        window.location.href = "/admin/dashboard";
      }
      return;
    }

    if (res.error) {
      handleError(res);
      return;
    } else {
      toast.success("Password reset successfully");
      // reload page
      window.location.href = "/eye-statistics";
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border-2 border-primary border-opacity-0 p-8 rounded-md shadow-md bg-white w-96 space-y-4"
    >
      <h2 className="text-2xl font-semibold mb-6 text-center text-primary">
        Reset Password
      </h2>

      <div className="space-y-2">
        <label
          htmlFor="oldPassword"
          className="block text-sm font-medium text-gray-700"
        >
          Current Password
        </label>
        <input
          type="password"
          id="oldPassword"
          name="oldPassword"
          value={formData.oldPassword}
          onChange={handleChange}
          required
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div className="space-y-2">
        <label
          htmlFor="newPassword"
          className="block text-sm font-medium text-gray-700"
        >
          New Password
        </label>
        <input
          type="password"
          id="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div className="space-y-2">
        <label
          htmlFor="confirmPassword"
          className="block text-sm font-medium text-gray-700"
        >
          Confirm New Password
        </label>
        <input
          type="password"
          id="confirmPassword"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
          required
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <button
        type="submit"
        className="main_btn w-full text-white py-2 px-4 rounded-md transition-colors mt-6"
      >
        Reset Password
      </button>
    </form>
  );
};
